import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import {  LoadingController } from "ionic-angular";
import { Http } from "@angular/http";

import config from "../../config/config";

import { HomePage } from "../home/home";


/**
 * Generated class for the AuxilioFormPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-auxilio-form',
  templateUrl: 'auxilio-form.html',
})
export class AuxilioFormPage {
  form: any = {};
  siape: any;
  itens: any = [];
  retorno = false;
  naoEncontrado = false;

  checagemOK = false;

  usuario: any;
  usuarioIdAuditoria;
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public loadingCtrl: LoadingController,
    public navParams: NavParams
    ) {}

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.usuarioIdAuditoria = this.navParams.get("usuarioIdAuditoria");
    console.log('ionViewDidLoad AuxilioFormPage');
    
  }

  buscaSiape(){
    this.checagemOK = false;
    this.retorno = false;
    this.naoEncontrado = false;
    this.itens = [];
    this._http
      .get(config.urlAPI + "usuario/buscasiape/" + this.form.siape,  {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        if (res.length) {
          this.form.nomeSiape = res[0].nome;
        this.form.cpfSiape = res[0].cpf;
        this.form.user_id = res[0].id;
        }else {
          this.form.nomeSiape = '';
          this.form.cpfSiape = '';
          this.form.user_id = '';
        }
        
      });
    
  }
  submeter(){
    let form = {
      user_id : this.form.user_id ,
      tipodeauxilio : this.form.tipodeauxilio ,
      datadoauxilio :  this.form.dataAuxilio,
      nome : this.form.nome ,
      requerente : this.form.requerente,
      usuario: this.usuarioIdAuditoria
    }
    // let checagem: any =  this.checagem(form);
    // if(checagem){
    //   console.log("foi encontrado matchs");
    //    console.log(checagem);
    // }else{
    //   console.log("sem match será salvo");

     
    // }
     this.salvar(form);
  }
  checagem(){
    this.checagemOK = false;
    this.retorno = false;
    this.naoEncontrado = false;
    this.itens = [];

    let form = {
      user_id : this.form.user_id ,
      tipodeauxilio : this.form.tipodeauxilio ,
      datadoauxilio :  this.form.dataAuxilio,
      nome : this.form.nome ,
      requerente : this.form.requerente
    }

    this._http
      .post(config.urlAPI + "auxilios/buscaNome", form, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
       
        
        console.log(res);
        if (res.length) {
          res.map(obj => {
            if (obj.tipodeauxilio == "N" || obj.tipodeauxilio == "n") {
              obj.tipodeauxilio =  "Nascimento";
            } else {
              obj.tipodeauxilio = "Falecimento";
            }
          })
          this.itens = res; 
          this.retorno = true;
          this.checagemOK = true;
        }else {
          this.naoEncontrado = true;
          this.checagemOK = true;
        }
      });
  }

  salvar(form){
    this._http
      .post(config.urlAPI + "auxilios/novo", form, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        console.log(res);
        if (res == true) {
          alert("dados gravados com sucesso")
          this.checagemOK = false;
          this.retorno = false;
          this.naoEncontrado = false;
          this.itens = [];
          this.navCtrl.push(HomePage, {

          });
        }
        

      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/auxilio-form/auxilio-form.ts